import { ContentLinkProps } from './content-card.constants';
import { useAuthorisedAction } from 'approot/shared/hooks/authorised-action.hooks';
import { generateContentLink } from './content-card.utils';

export const useGenerateItemLink = ({
  item,
  isAlwaysViewable,
  canOpenStimulus,
  slugOverride,
}: {
  item: ContentLinkProps;
  isAlwaysViewable: boolean;
  canOpenStimulus: boolean;
  slugOverride?: string | null;
}) => {
  const { unauthorisedAccessHref } = useAuthorisedAction();

  if (item.disabled) {
    return null;
  }

  if (slugOverride) {
    return slugOverride;
  }

  if (isAlwaysViewable) {
    if (!item.type) {
      return item.slug;
    }
    return generateContentLink(true, item.type, item.slug, item.link);
  }

  const link = unauthorisedAccessHref();
  return link
    ? link
    : generateContentLink(
        canOpenStimulus,
        item.type || '',
        item.slug,
        item.link
      );
};
